import { useState } from 'react';
import { X, Search, ArrowUpDown, ChevronDown } from 'lucide-react';
import taricData from '../../../taric_tables_data.json';

// Utility to get modos de transporte soivre from taric_tables_data.json
export function getModosTransporteSoivre() {
  return (taricData['modos-de-transporte-soivre'] || []).map((modo) => ({
    nombre: modo.descripcion,
    codigo: modo.codigo,
  }));
}

// Predefined list for modo_transporte_frontera (Border Transport Mode)
export function getModosTransporteFronteraPredefinidos() {
  return [
    { codigo: "1", nombre: "Transporte Marítimo" },
    { codigo: "2", nombre: "Transporte por Ferrocarril" },
    { codigo: "3", nombre: "Transporte por Carretera" },
    { codigo: "4", nombre: "Transporte por vía Aérea" },
    { codigo: "5", nombre: "Envíos Postales" },
    { codigo: "7", nombre: "Instalaciones de transporte fijas" },
    { codigo: "8", nombre: "Transporte por vías de navegación interior" },
    { codigo: "9", nombre: "Autopropulsión" },
    { codigo: "0", nombre: "Otros" },
  ];
}

export const ModosTransporteSoivreModal = ({
  modos = [],
  isOpen,
  onClose,
  onSelect,
  selectedModo,
  title = 'Select Transport Mode',
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('code-asc');
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = [
    { value: 'code-asc', label: 'Code (0-9)' },
    { value: 'code-desc', label: 'Code (9-0)' },
    { value: 'name-asc', label: 'Name (A-Z)' },
    { value: 'name-desc', label: 'Name (Z-A)' },
  ];

  const filteredModos = modos.filter((modo) =>
    modo.nombre.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortedModos = [...filteredModos].sort((a, b) => {
    switch (sortBy) {
      case 'code-asc':
        return Number(a.codigo) - Number(b.codigo);
      case 'code-desc':
        return Number(b.codigo) - Number(a.codigo);
      case 'name-asc':
        return a.nombre.localeCompare(b.nombre);
      case 'name-desc':
        return b.nombre.localeCompare(a.nombre);
      default:
        return 0;
    }
  });

  const getSortLabel = () => {
    return sortOptions.find((option) => option.value === sortBy)?.label || 'Sort by';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{title}</h2>
          <button
            onClick={() => {
              setSearchQuery('');
              setIsSortOpen(false);
              onClose();
            }}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {/* Search Input */}
          <div className="relative flex items-center gap-2 border-container rounded-full px-3 py-1 flex-1 flex-row">
            <div className="flex-0 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="pr-4 py-2 !border-none no-border search-input"
              style={{ borderWidth: '0px !important', border: '0px !important' }}
              placeholder="Search modos de transporte soivre..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Custom Sort Dropdown */}
          <div className="relative button-no-hover-effect text-sm">
            <button
              className="flex items-center gap-2 px-2 pr-0 py-2 rounded-full"
              onClick={() => setIsSortOpen(!isSortOpen)}
            >
              <ArrowUpDown className="w-4 h-4" />
              <span>{getSortLabel()}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isSortOpen ? 'rotate-180' : ''}`} />
            </button>

            {isSortOpen && (
              <div className="overflow-hidden absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border-container py-1 z-10">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                      sortBy === option.value ? 'text-primary' : 'text-gray-700'
                    }`}
                    onClick={() => {
                      setSortBy(option.value);
                      setIsSortOpen(false);
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="max-h-[60vh] min-h-[60vh] overflow-y-auto">
          {modos.length > 0 ? (
            <div className="space-y-0">
              {sortedModos.length > 0 ? (
                sortedModos.map((modo) => (
                  <div
                    key={modo.codigo || modo.nombre}
                    className={`p-3 px-0 hover:bg-gray-100 cursor-pointer border-bottom-gray ${
                      selectedModo &&
                      (selectedModo.codigo === modo.codigo || selectedModo.nombre === modo.nombre)
                        ? 'bg-gray-100 font-bold'
                        : ''
                    }`}
                    onClick={() => {
                      onSelect(modo);
                      setSearchQuery('');
                      setIsSortOpen(false);
                      onClose();
                    }}
                  >
                    <div className="flex justify-between items-start gap-2">
                      <div>
                        <p className="font-medium">{modo.nombre}</p>
                        {modo.codigo && (
                          <p className="text-xs text-gray-500">{modo.codigo}</p>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-4 text-gray-500">
                  No transport modes found matching "{searchQuery}"
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-4">
              <p className='opacity-75 mb-4'>No Transport Modes Available</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 